
import React from 'react';
import {Popover, Card, Typography, Space} from 'antd';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import ColoredTag from "../../components/Tags/ColoredTag";
import useTickerCalendar from './useTickerCalendar';


export const UPCOMING_EARNINGS_COLOR = 'var(--red)';
export const UPCOMING_DIVIDEND_COLOR = 'var(--blue)';



export const TickerEventLegend = ()=>{
    return (
        <Space>
            <ColoredTag color={UPCOMING_EARNINGS_COLOR} name={'Upcoming Earnings'} width={160} shadow={false}/>
            <ColoredTag color={UPCOMING_DIVIDEND_COLOR} name={'Upcoming Dividends'} width={160} shadow={false}/>
        </Space>
    )
}


const localizer = momentLocalizer(moment);



const eventPropGetter = (event) => {
    const backgroundColor = event.type === 'upcomingdividend' ? UPCOMING_DIVIDEND_COLOR : UPCOMING_EARNINGS_COLOR; // Green for dividends, Blue for earnings
    return {
        style: {
            background: `linear-gradient(to right, ${backgroundColor} 3px, #fff 3px)`,  fontSize: '12px', fontFamily: 'Roboto, sans-serif', paddingTop: '0px', paddingBottom: '0px',
            textShadow: "0px 1px 1px rgba(0, 0, 0, 0.2)", letterSpacing: '0.04em', textTransform: 'uppercase', color: backgroundColor,
            borderRadius: '0'
        }
    };
};


const EventPopover = ({ events }) => (
    <div>
        {events.map(event => (
            <Typography key={event.title}>
                <strong>{event.title}</strong>
                <div>{event.description}</div>
            </Typography>
        ))}
    </div>
);


const TickerCalendar = ()=>{

    const { events } = useTickerCalendar();


    return (
        <Card
            bordered={false}
            title={
            <Space>
                <Typography.Title level={4}>Event Calendar</Typography.Title>
            </Space>
            }
            extra={
            <TickerEventLegend  />
            }
        >
            <Calendar
                className={'light'}
                localizer={localizer}
                events={events}
                eventPropGetter={eventPropGetter}
                startAccessor="start"
                endAccessor="end"
                style={{ height: '85vh', width: '100%' }}
                components={{
                    month: {
                        event: ({ event }) => (
                            <Popover content={<EventPopover events={[event]} />} title="Event Details" trigger="hover">
                                <span style={{fontSize: '10px'}}>{event.title}</span>
                            </Popover>
                        )
                    },
                    day: {
                        event: ({ event }) => (
                            <Typography>
                                <strong style={{color: "#000", fontWeight: '300', fontSize: '14px'}}>{event.title}</strong>
                                <div style={{color: "#aaaccc", fontWeight: '300', fontSize: '12px'}}>{event.description}</div>
                            </Typography>
                        )
                    }
                }}
            />
        </Card>
    )

}

export default TickerCalendar;
